import CategoriseContentController from './CategoriseContent.controller'
import CategoriseContentView from './CategoriseContent.view.vue'

export default CategoriseContentController(CategoriseContentView)
